export const facebook = {
  "appId": "1683074395159437",
  "secret": "b5a91e5356c2d2fdce45bac4cb086aca"
};